import { usePlatformAccessLevel } from '../features/platformPermissions/usePlatformAccessLevel';
import { OrganizationStandardsSelector } from '../features/organizationStandards/components/OrganizationStandardsSelector';

export function OrganizationStandardsPage() {
  const { canEdit } = usePlatformAccessLevel('admin.standards');

  return (
    <div className="p-4 md:p-6">
      <OrganizationStandardsSelector canEdit={canEdit} variant="page" />
    </div>
  );
}
